import ApiResponse from '@/models/entities/api/api-response';
import { validateStringProperty } from '@/models/entities/type-utils';

export default class ResendVerificationCodeResponse extends ApiResponse {
  data: string;

  constructor(source: unknown) {
    super(source);
    this.data = validateStringProperty(source, 'data', false);
  }
}
